import { useAppSelector } from 'app/store';
import { ROLE_TENANT_DIRECTOR } from '../../constants';

export function isDirector(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.includes(ROLE_TENANT_DIRECTOR) ?? false;
}
